import "/polyfills/closest";

document.addEventListener("click", e => {
  const toggle = e.target.closest(".js-toggle-social-signup-list");
  if (!toggle) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const form = toggle.closest(".auth-form");
  form.classList.add("auth-form--show-social-signup");
});
